import React from 'react';
import PropTypes from 'prop-types';
import { mediaQueryHOC } from '../../adapters/helpers/Hooks'
import dynamic from 'next/dynamic';
const StackedProductsOverView = dynamic(() => import('./mobile/StackedProductsOverview'));
const CarrouselProductsOverView = dynamic(() => import('./mobile/CarrouselProductsOverview'));
const CollapsibleProductsOverview = dynamic(() => import('./desktop/CollapsibleProductsOverview'));

function ProductsOverview({
    products = [],
    seeMoreProductsText,
    seeLessProductsText,
    itemsPerLine = 3,
    whiteText,
    isCarrousel = false,
    isMedium,
    onClickCallback,
    productOverview,
    removeLazyLoad = false,
    isRecentlyViewed = false}) {
    return (
        <div>
            {isMedium ?
                (isCarrousel ?
                    <CarrouselProductsOverView products={products}
                        whiteText={whiteText} onClickCallback={onClickCallback} productOverview={productOverview} isMedium={isMedium} removeLazyLoad={removeLazyLoad} /> :
                    <StackedProductsOverView products={products}
                        whiteText={whiteText} onClickCallback={onClickCallback} productOverview={productOverview} isMedium={isMedium} removeLazyLoad={removeLazyLoad} />) :
                <CollapsibleProductsOverview products={products}
                    seeMoreProductsText={seeMoreProductsText}
                    seeLessProductsText={seeLessProductsText}
                    whiteText={whiteText}
                    isRecentlyViewed={isRecentlyViewed}
                    itemsPerRow={itemsPerLine} onClickCallback={onClickCallback}
                    productOverview={productOverview} removeLazyLoad={removeLazyLoad} />
            }
        </div>
    );
}

export default mediaQueryHOC(ProductsOverview);

ProductsOverview.propTypes = {
    itemsPerLine: PropTypes.number,
    children: PropTypes.any,
    seeMoreProductsText: PropTypes.string,
    seeLessProductsText: PropTypes.string,
    products: PropTypes.any,
    whiteText: PropTypes.any,
    isMedium: PropTypes.bool,
    isCarrousel: PropTypes.bool,
    isRecentlyViewed: PropTypes.bool,
    removeLazyLoad: PropTypes.bool,
    onClickCallback: PropTypes.func.isRequired,
    productOverview: PropTypes.any
}
